<template>
  <div class="warehousing-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="right"
      :show-message="false"
    >
      <el-collapse :value="collapse">
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              :disabled="true"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('SeaExport.BusinessNo')"
                    prop="jobNo"
                  >
                    <el-input v-model="form.jobNo" no="1" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('RailwayExport.ETD'):'ETD'"
                    prop="ETD"
                  >
                    <el-input v-model="form.etdString" no="2" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('SeaExport.departureStation'):$t('SeaExport.PortOfLoadingAI')"
                    prop="portOfLoading"
                  >
                    <el-input v-model="form.loadingPortEnglish" no="3" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="getMAWBName()"
                    prop="mbl"
                  >
                    <el-input v-model="form.mbl" no="4" />
                  </el-form-item>

                  <el-form-item
                    :label="getCarrierName()"
                    prop="carrierId"
                  >
                    <el-input v-model="form.carrierName" no="5" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('SeaExport.destinationStation'):$t('SeaExport.PortOfDestination')"
                    prop="portOfDestination"
                  >
                    <el-input v-model="form.destinationPortEnglish" no="6" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="getHblName()"
                    prop="hbl"
                  >
                    <el-input v-model="form.hbl" no="7" />
                  </el-form-item>
                  <el-form-item
                    :label="getFlightAndTime()"
                    prop="flightAndTime"
                  >
                    <el-input v-model="form.flightAndTime" no="8" />
                  </el-form-item>
                  <el-form-item
                    v-show="$checkPermission(['button_SEBooking_addSEBooking'])"
                    :label="$t('SeaExport.ConsignationCompany')"
                    prop="customerName"
                  >
                    <el-input v-model="form.customerName" no="9" :title="form.customerName" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.WarehouseInformation') }}</span>
          <!--          <div v-if="!isAe" class="form-row" style="display:flex;flex-direction:row;">-->
          <!--            <el-form-->
          <!--              label-width="100px"-->
          <!--              label-position="right"-->
          <!--              style="margin-right:10px"-->
          <!--            >-->
          <!--              <el-row>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-form-item-->
          <!--                    class="required"-->
          <!--                    :label="$t('Warehouse.WarehouseNo')"-->
          <!--                    prop="warehouseNo"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.warehouseNo" style="width:95%;" :disabled="!isEditing" @change="warehouseNoChargeHandler" />-->
          <!--                  </el-form-item>-->

          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.ReceiptNo')"-->
          <!--                    prop="receiptNo"-->
          <!--                    class="auto-width"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.receiptNo" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.WarehouseName')"-->
          <!--                    prop="warehouse"-->
          <!--                    class="auto-width required"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.warehouse" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->

          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.Warehouseman')"-->
          <!--                    prop="warehouseOp"-->
          <!--                    class="auto-width"-->
          <!--                  >-->
          <!--                    <cargo-user-select-->
          <!--                      :method-params="{officeId:form.opOffice,category:'role',shape:'warehouseOp'}"-->
          <!--                      :default-value="form.warehouseOp||''"-->
          <!--                      :disabled="!isEditing"-->
          <!--                      style="width:95%;"-->
          <!--                      @change="p=>{form.warehouseOp=p.value}"-->
          <!--                    />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.WarehouseLocation')"-->
          <!--                    prop="location"-->
          <!--                    class="auto-width"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.location" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    class="required"-->
          <!--                    :label="$t('Warehouse.StorageDate')"-->
          <!--                    prop="warehouseInDate"-->
          <!--                  >-->
          <!--                    <el-date-picker-->
          <!--                      v-model="form.warehouseInDate"-->
          <!--                      type="datetime"-->
          <!--                      :disabled="!isEditing"-->
          <!--                      value-format="yyyy-MM-dd HH:mm:ss"-->
          <!--                      format="yyyy-MM-dd HH:mm"-->
          <!--                      style="width: 95%;"-->
          <!--                    />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.DeliveryDate')"-->
          <!--                    prop="warehouseOutDate"-->
          <!--                    class="auto-width"-->
          <!--                  >-->
          <!--                    <el-date-picker-->
          <!--                      v-model="form.warehouseOutDate"-->
          <!--                      type="datetime"-->
          <!--                      :disabled="!isEditing"-->
          <!--                      value-format="yyyy-MM-dd HH:mm:ss"-->
          <!--                      format="yyyy-MM-dd HH:mm"-->
          <!--                      style="width: 95%;"-->
          <!--                    />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.DeliveryMode')"-->
          <!--                    prop="outType"-->
          <!--                    class="auto-width"-->
          <!--                  >-->
          <!--                    <el-select-->
          <!--                      v-model="form.outType"-->
          <!--                      clearable-->
          <!--                      style="width: 95%;"-->
          <!--                      :disabled="!isEditing"-->
          <!--                      :placeholder="$t('Message.PleaseSelect')"-->
          <!--                      size="mini"-->
          <!--                    >-->
          <!--                      <el-option-->
          <!--                        v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"-->
          <!--                        :key="index"-->
          <!--                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"-->
          <!--                        :value="item.code"-->
          <!--                      />-->
          <!--                    </el-select>-->
          <!--                  </el-form-item>-->
          <!--                </el-col>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.PalletSum')"-->
          <!--                    prop="palletSum"-->
          <!--                  >-->
          <!--                    <el-input-number v-model="form.palletSum" controls-position="right" :max="10" :min="0" style="width:95%;" :precision="0" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.DeliveryCmp')"-->
          <!--                    prop="DeliveryCmp"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.deliveryCmp" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.LicensePlate')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.truckNo" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.Driver')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.driver" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.DriverPhone')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.driverTel" style="width:95%;" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.Remark')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.remarks" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    prop="isBroken"-->
          <!--                  >-->
          <!--                    <el-checkbox v-model="form.sealCargo" :disabled="!isEditing" @change="checkboxChangeHandler">{{ $t('Warehouse.IsTheGoodsClosed') }}-->
          <!--                    </el-checkbox>-->
          <!--                  </el-form-item>-->
          <!--                </el-col>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-form-item-->
          <!--                    prop="isBroken"-->
          <!--                  >-->
          <!--                    <el-checkbox v-model="form.broken" :disabled="!isEditing" @change="checkboxChangeHandler">{{ $t('Warehouse.IsNotComputationIsAffectedByDampness') }}-->
          <!--                    </el-checkbox>-->
          <!--                  </el-form-item>-->

          <!--                  <el-form-item-->
          <!--                    prop="receiveDc"-->
          <!--                  >-->
          <!--                    <el-checkbox v-model="form.receiveDc" :disabled="!isEditing">{{ $t('Warehouse.ReceiveDc') }}</el-checkbox>-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')"-->
          <!--                    prop="brokenNum"-->
          <!--                  >-->
          <!--                    <el-input-number v-model="form.brokenQuantity" :min="0" :max="99999" controls-position="right" style="width:95%;" :precision="0" :disabled="!(isEditing && form.broken)" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.DescriptionOfGoods')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.brokenDes" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.HandlingOpinions')"-->
          <!--                    prop="licensePlate"-->
          <!--                  >-->
          <!--                    <el-input v-model="form.comments" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />-->
          <!--                  </el-form-item>-->
          <!--                  <el-form-item-->
          <!--                    :label="$t('Warehouse.SealingWeight')"-->
          <!--                    prop="brokenNum"-->
          <!--                  >-->
          <!--                    <el-input-number v-model="form.sealWeight" :min="0" :max="999999999999" controls-position="right" style="width:95%;" :precision="1" :disabled="!(isEditing && form.sealCargo)" />-->
          <!--                  </el-form-item>-->
          <!--                </el-col>-->
          <!--              </el-row>-->
          <!--            </el-form>-->
          <!--          </div>-->
          <!--空运出口显示-->
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="6">
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.WarehouseNo')"
                    prop="warehouseNo"
                  >
                    <el-input v-model="form.warehouseNo" no="10" style="width:95%;" :disabled="!isEditing" @change="warehouseNoChargeHandler" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseName')"
                    prop="warehouse"
                    class="auto-width required"
                  >
                    <el-input v-model="form.warehouse" no="11" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Warehouseman')"
                    prop="warehouseOp"
                    class="auto-width"
                  >
                    <cargo-user-select
                      no="12"
                      :method-params="{officeId:form.opOffice,category:'role',shape:'warehouseOp'}"
                      :default-value="form.warehouseOp||''"
                      :disabled="!isEditing"
                      style="width:95%;"
                      @change="p=>{form.warehouseOp=p.value}"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="isAe"
                    :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')"
                    prop="estimatedWarehousingTime"
                  >
                    <el-date-picker
                      v-model="form.estimatedWarehousingTime"
                      no="13"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    class="required"
                    :label="$t('CargoMsg.Cargo_ActualWarehousingTime')"
                    prop="warehouseInDate"
                  >
                    <el-date-picker
                      v-model="form.warehouseInDate"
                      no="14"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="isAe"
                    :label="$t('CargoMsg.Cargo_EstimatedDeliveryTime')"
                    prop="estimatedDeliveryTime"
                  >
                    <el-date-picker
                      v-model="form.estimatedDeliveryTime"
                      no="15"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('CargoMsg.Cargo_ActualDeliveryTime')"
                    prop="warehouseOutDate"
                    class="auto-width"
                  >
                    <el-date-picker
                      v-model="form.warehouseOutDate"
                      no="16"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('Warehouse.ReceiptNo')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="form.receiptNo" no="17" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryCmp')"
                    prop="DeliveryCmp"
                  >
                    <el-input v-model="form.deliveryCmp" no="18" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.LicensePlate')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.truckNo" no="19" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Driver')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driver" no="20" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DriverPhone')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driverTel" no="21" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    prop="location"
                    class="auto-width"
                  >
                    <line-label slot="label" :label="$t('Warehouse.WarehouseLocation')" />
                    <el-input v-model="form.location" no="22" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryMode')"
                    prop="outType"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.outType"
                      no="23"
                      clearable
                      style="width: 95%;"
                      :disabled="!isEditing"
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('Warehouse.PalletSum')"
                    prop="palletSum"
                  >
                    <el-input-number v-model="form.palletSum" no="24" controls-position="right" :max="10" :min="0" style="width:95%;" :precision="0" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    prop="receiveDc"
                  >
                    <el-checkbox v-model="form.receiveDc" no="25" :disabled="!isEditing">{{ $t('Warehouse.ReceiveDc') }}</el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.broken" no="26" :disabled="!isEditing" style="width: 100%;" @change="checkboxChangeHandler">
                      <div :title="$selectByLang('', $t('Warehouse.IsNotComputationIsAffectedByDampness'))" :style="$selectByLang('', 'width: 135px;overflow: hidden;text-overflow: ellipsis;')">{{ $t('Warehouse.IsNotComputationIsAffectedByDampness') }}</div>
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="brokenNum"
                  >
                    <line-label slot="label" :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')" />
                    <el-input-number v-model="form.brokenQuantity" no="27" :min="0" :max="99999" controls-position="right" style="width:95%;" :precision="0" :disabled="!(isEditing && form.broken)" />
                  </el-form-item>
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.sealCargo" no="28" :disabled="!isEditing" @change="checkboxChangeHandler">{{ $t('Warehouse.IsTheGoodsClosed') }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.SealingWeight')"
                    prop="brokenNum"
                  >
                    <el-input-number v-model="form.sealWeight" no="29" :min="0" :max="999999999999" controls-position="right" style="width:95%;" :precision="1" :disabled="!(isEditing && form.sealCargo)" />
                  </el-form-item>
                  <el-form-item
                    v-if="showWarehouseStatus"
                    :label="$t('Warehouse.WarehouseInState')"
                    no="WarehouseInState"
                    prop="WarehouseInState"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.warehouseStatus"
                      no="30"
                      clearable
                      style="width: 95%;"
                      :disabled="true"
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    prop="licensePlate"
                  >
                    <line-label slot="label" :label="$t('Warehouse.DescriptionOfGoods')" />
                    <el-input v-model="form.brokenDes" no="31" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.HandlingOpinions')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.comments" no="32" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Remark')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.remarks" no="33" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    prop="temperatureRequirement"
                    class="auto-width"
                  >
                    <line-label slot="label" :label="$t('Warehouse.TemperatureRequirement')" />
                    <el-select
                      v-model="form.temperatureRequirement"
                      no="temperatureRequirement"
                      filterable
                      allow-create
                      clearable
                      style="width: 95%;"
                      :disabled="!isEditing"
                      :placeholder="' '"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in TemperatureRequirements.TEMPERATURE_REQUIREMENTS"
                        v-if="item.tenantId === $store.getters.tenantId"
                        :key="index"
                        :label="item.requirements"
                        :value="item.requirements"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%;min-width:1000px">
          <span class="title">{{ $t('Warehouse.CargoDetails') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <el-form class="spacing">
                  <el-button no="34" type="primary" :disabled="!isEditing" @click="addDetailHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
                  <el-button no="35" type="danger" :disabled="!isEditing" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
                </el-form>
                <cargo-ag-grid
                  ref="goodsTable"
                  config-module="9300002"
                  :grid-options="detailList.goodGridOptions"
                  :column-defs="goodsColumn"
                  :row-data="form.warehouseInDetailList || []"
                  style="height: 200px;"
                  @gridReady="params=>{detailList.gridApi=params.api}"
                />
                <el-form-item class="auto-width">
                  <div style="display: flex;text-align: left" class="title-row">
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Weight2') }} {{ openImperial ? '(LB)' : 'KGS' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }} {{ openImperial ? '(CFT)' : 'CBM' }}</div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Actual')" class="auto-width">
                  <el-input-number v-model="form.quantitySum" no="36" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                  <el-input-number v-show="!openImperial" v-model="form.weightSum" no="37" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.weightSumImperial" no="37" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="!openImperial" v-model="form.cubageSum" no="38" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.cubAgeSumImperial" no="38" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Consignation')" class="auto-width">
                  <el-input-number v-model="form.quantityContract" no="39" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                  <el-input-number v-show="!openImperial" v-model="form.weightContract" no="40" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.weightContractImperial" no="40" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="!openImperial" v-model="form.cubageContract" no="41" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.cubAgeContractImperial" no="41" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <el-form class="spacing">
                <el-upload
                  :action="`${URL.warehouseIn.uploadFileForWarehouseIn}?warehouseInUuid=${warehouseInUuid}`"
                  :headers="{sessionId:$store.getters.token}"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-change="toChooseFile"
                  :disabled="!isEditing"
                  style="display: inline-block;margin-right: 5px;"
                >
                  <el-button no="42" type="primary" :disabled="!isEditing">{{ $t('Warehouse.SelectFile') }}</el-button>
                </el-upload>

                <el-button type="danger" :disabled="!isEditing" no="43" @click="delPhotoHandler">{{ $t('Warehouse.DeleteFile') }}</el-button>
              </el-form>
              <cargo-ag-grid
                ref="photosList"
                config-module="9300003"
                :grid-options="photoList.gridOptions"
                :column-defs="photoList.photoColumn"
                :row-data="form.businessDocumentVOList"
                @gridReady="params=>{photoList.gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.OperationRequirements') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <cargo-ag-grid
                  ref="opList"
                  config-module="9300004"
                  :grid-options="opList.options"
                  :column-defs="opList.opColumn"
                  :row-data="form.operationRequirementVOList"
                  @gridReady="params=>{opList.gridApi=params.api}"
                />
              </div>
            </el-form>
          </div>
        </div>
      </el-collapse>
    </el-form>

    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="fileTypeEditor.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="itemEditEndHandler"
    />
    <!-- 选择业务弹框 -->
    <job-nos-window
      v-if="jobNosWindow.visible"
      :visible.sync="jobNosWindow.visible"
      :job-nos="jobNosWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import { detail, getJobDetailFunc, queryJobByWarehouseNoFunc } from '@/api/warehouseIn/warehouseIn'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import ColumnUtils from '@/utils/ColumnUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { WarehouseInDetail } from '@/class/model/booking/WarehouseInDetail'
import * as NumberUtils from '@/utils/NumberUtils'
import JobNosWindow from './jobNosWindow'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoAgGridDimensionEditor from '@/components/Cargo/Common/CargoAgGridDimensionEditor'
import { IMPERIAL_5 } from '@/class/cargo/model/parameters/SystemConstants'
import * as TemperatureRequirements from '@/class/cargo/model/parameters/TemperatureRequirements'

export default {
  name: 'WarehousingDetail',
  components: {
    JobNosWindow,
    cargoAdvanceSelect,
    cargoUserSelect,
    cargoCompanySelect,
    MxFileTypeEditor,
    CargoDateTimePicker
  },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    action: { type: String, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      TemperatureRequirements,
      WarehouseInState,
      documentTypeUtil: null,
      selectTypeNames: TYPE_NAMES,
      URL,
      storageURL: '',
      filter: {},
      addCargoVisible: false,
      gridApi: null,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        lob: 'SE',
        fileCategory: ''
      },
      jobNosWindow: {
        visible: false,
        jobs: []
      },
      fileTypeMap: {},
      jobKeyOld: '',
      openImperial: false, // 英制单位
      form: {
        uuid: '',
        jobKey: '',
        jobNo: '',
        warehouseNo: '',
        carrierName: '',
        flightAndTime: '',
        vessel: '',
        portOfLoading: '',
        licensePlate: '',
        customerName: '',
        brokenNum: 0,
        portOfDestination: '',
        warehouseInDateTo: '',
        warehouse: '',
        warehouseOp: 0,
        etdString: '',
        hbl: '',
        mbl: '',
        destinationPortEnglish: '',
        loadingPortEnglish: '',
        voyageFlight: '',
        state: 0,
        createdBy: 0,
        dateCreated: 0,
        branchId: this.$store.getters.currentOfficeId,
        warehouseInDate: null,
        location: '',
        palletSum: 0,
        quantitySum: 0,
        weightSum: 0.00,
        cubageSum: 0.000,
        quantityContract: 0,
        weightContract: 0.00,
        cubageContract: 0.000,
        version: null,
        receiptNo: '',
        deliveryCmp: '',
        truckNo: '',
        vehicleType: '',
        driver: '',
        driverTel: '',
        remarks: '',
        broken: false,
        receiveDc: false,
        brokenQuantity: 0,
        sealCargo: 0,
        brokenDes: '',
        comments: '',
        warehouseOutDate: '',
        estimatedDeliveryTime: '',
        estimatedWarehousingTime: '',
        outType: '',
        label: '',
        sealWeight: '',
        lob: this.lob,
        referenceNo: '',
        warehouseStatus: 0, // 入库状态
        businessDocumentVOList: [],
        operationRequirementVOList: [],
        warehouseInDetailList: [],
        temperatureRequirement: ''
      },
      detailList: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridDimensionEditor
          }
        }
      },
      photoList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            this.onFileTypeCellFocused(event)
          },
          columnApi: null
        }, photoColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 150,
            cellRenderer: params => {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileType'),
            colId: 'fileType',
            field: 'fileType',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_UploadTime'), colId: 'dateCreated', field: 'dateCreated', width: 150 },
          { headerName: this.$t('SeaExport.DocumentType'), colId: 'fileCategory', field: 'fileCategory', width: 150,
            cellRenderer: params => {
              return this.documentTypeUtil.fileTypeLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.UploadProgress'),
            colId: 'documentId',
            field: 'documentId',
            width: 115,
            cellRenderer: params => {
              if (params.value && !params.data.newData) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (!this.isEditing && params.data.newData) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          }
        ]
      },
      opList: {
        gridApi: null,
        options: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          columnApi: null,
          context: {
            componentParent: this
          }
        },
        opColumn: [
          {
            headerName: this.$t('CargoMsg.Cargo_OperationRequirement'), colId: 'contentDescription', field: 'contentDescription', width: 750,
            editable: false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Finished'),
            field: 'finished',
            suppressMenu: true,
            width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isEditing,
              tag: 'el-checkbox',
              valueChanged: p => { this.onCellChange(p) }
            }
          }
        ]
      },
      opGridParams: {},
      collapse: [0, 1, 2, 3, 4, 5],
      warehouseInInfo: null
    }
  },
  computed: {
    readonly() {
      return !this.isEditing
    },
    detailListSelectedRow() {
      return this.form.warehouseInDetailList[this.detailList.goodGridOptions.selectedRowIndex]
    },
    photoListSelectedRow() {
      return this.form.businessDocumentVOList[this.photoList.gridOptions.selectedRowIndex]
    },
    isEditing() {
      return this.action !== 'look'
    },
    isAe() {
      const lob = this.form.lob ? this.form.lob : this.lob
      return lob === 'AE'
    },
    showWarehouseStatus() { // 入库状态 控制
      const lob = this.form.lob ? this.form.lob : this.lob
      return lob === 'AE' || lob === 'SE'
    },
    goodsColumn() {
      let list = [
        {
          headerName: this.$t('SeaExport.PackageType'),
          field: 'packing',
          colId: 'packing',
          suppressMenu: true,
          width: 150,
          editable: () => this.isEditing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: 'chineseName',
              selectType: TYPE_NAMES.basic_data_Packing,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_measurements'),
          field: 'dimension',
          colId: 'dimension',
          maxWidth: 500,
          minWidth: 300,
          editable: () => this.isEditing,
          suppressKeyboardEvent: this.suppressKeyboardEvent,
          cellEditor: 'CargoAgGridDimensionEditor',
          cellEditorParams: {
            valueChanged: this.calculationDimension
          },
          onCellValueChanged: this.calculationDimension
        },
        {
          headerName: this.$t('SeaExport.SingleWeight') + 'KGS',
          field: 'singleWeight',
          colId: 'singleWeight',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.singleWeightChange(params, false)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          colId: 'quantity',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Weight2') + 'KGS',
          field: 'weight',
          colId: 'weight',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        },
        {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          colId: 'cubage',
          suppressMenu: true,
          width: 150,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubageChange(params, false)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks',
          colId: 'remarks', suppressMenu: true,
          minWidth: 200,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false
          }
        }
      ]
      if (this.lob === 'AE' && this.openImperial) {
        list = [
          {
            headerName: this.$t('SeaExport.PackageType'),
            field: 'packing',
            colId: 'packing',
            suppressMenu: true,
            width: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagName: 'chineseName',
                selectType: TYPE_NAMES.basic_data_Packing,
                callbackParams: { key: 'code' },
                callbackMethodType: 'value',
                filterable: true
              }
            },
            valueFormatter: params => {
              return ColumnUtils.packingCodeLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_measurements2'),
            field: 'dimensionImperial',
            colId: 'dimensionImperial',
            maxWidth: 500,
            minWidth: 300,
            editable: () => this.isEditing,
            suppressKeyboardEvent: this.suppressKeyboardEvent,
            cellEditor: 'CargoAgGridDimensionEditor',
            cellEditorParams: {
              valueChanged: this.calculationDimensionImperial
            },
            onCellValueChanged: this.calculationDimensionImperial
          },
          {
            headerName: this.$t('SeaExport.SingleWeight') + '(LB)',
            field: 'singleWeightImperial',
            colId: 'singleWeightImperial',
            suppressMenu: true,
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.singleWeightChange(params, true)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
            field: 'quantity',
            colId: 'quantity',
            suppressMenu: true,
            width: 120,
            // 是否开启编辑
            editable: false,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Weight2') + '(LB)',
            field: 'weightImperial',
            colId: 'weightImperial',
            suppressMenu: true,
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.weightChange(params, true)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Cubage') + '(CFT)',
            field: 'cubAgeImperial',
            colId: 'cubAgeImperial',
            suppressMenu: true,
            width: 150,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
            },
            onCellValueChanged: (params) => {
              this.cubageChange(params, true)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks',
            colId: 'remarks', suppressMenu: true,
            minWidth: 200,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: false
            }
          }
        ]
      }
      return list
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
      if (this.lob === 'AE') {
        await JobUtils.initImperialData(IMPERIAL_5.code).then(r => {
          this.openImperial = r
        })
      }
    },
    async onShow(action, row) {
      await cache.load(cacheName.CONFIG)
      this.action = action
      this.storageURL = cache.config.get('StorageURL')
      if (this.action === 'add') {
        await this.buildNewRow(row)
      } else {
        this.handleGetWarehouseInInfo()
      }
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.warehouseInUuid = response.data.warehouseInUuid
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        this.form.businessDocumentVOList.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    onCellChange() {
    },
    handleGetWarehouseInInfo() {
      this.loading = getLoading()
      const { warehouseInUuid } = this
      this.clearPage()
      detail({ warehouseInUuid: warehouseInUuid, type: this.lob })
        .then((res) => {
          this.warehouseInInfo = res.data
          Object.keys(this.form).forEach((key) => {
            this.loading.close()
            if (res.data[key]) {
              this.form[key] = res.data[key]
              this.jobKeyOld = this.form.jobKey
              if (key === 'warehouseInDetailList' && this.form.warehouseInDetailList.length > 0) {
                for (const detail of this.form.warehouseInDetailList) {
                  if (detail.dimension) { // 拆分长宽高件数
                    const array = detail.dimension.split('*')
                    detail.sizeLength = array[0]
                    detail.sizeWidth = array[1]
                    detail.sizeHeight = array[2]
                    detail.sizeQuantity = array[3]
                  }
                }
              }
            }
          })
          this.form.flightAndTime = this.voyageFlightStr()
          // 清空选中背景色
          this.detailList.gridApi.clearFocusedCell()
          this.photoList.gridApi.clearFocusedCell()
          this.opList.gridApi.clearFocusedCell()
        })
        .catch(() => {
          this.loading.close()
        })
      this.loading.close()
    },
    rowDoubleClicked(row) {

    },
    clearPage() {
      this.form = PriceUtils.resetFilter(this.form)
    },
    getSubmitData() {
      this.form.lob = this.lob
      this.form.branchId = this.$store.getters.currentOfficeId
      const form = { ...this.form }
      return {
        form
      }
    },
    checkboxChangeHandler() {
      if (!this.form.broken) {
        this.form.brokenQuantity = 0
      }
      if (!this.form.sealCargo) {
        this.form.sealWeight = 0
      }
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      this.clearPage()
      this.form.warehouseOp = this.$store.getters.userId
      this.form.warehouseInDate = DateUtils.formatStandardDateTime(new Date())
      // 来自待入库清单的业务 提前放在页面上
      if (row && row.job) {
        const job = row.job
        this.form.jobUuid = job.uuid
        this.form.jobKey = job.uuid
        this.form.jobNo = job.jobNo
        this.form.etdString = job.etd
        this.form.loadingPortEnglish = ColumnUtils.portLabelFunc(job, job.loadingPortCode)
        this.form.mbl = job.mbl
        this.form.hbl = job.hblNbr2
        this.form.carrierName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.carrierId, 'chineseName')
        this.form.destinationPortEnglish = ColumnUtils.portLabelFunc(job, job.destinationPortCode)
        this.form.flightAndTime = job.vessel && job.voyageFlight ? job.vessel + '/' + job.voyageFlight : job.vessel || job.voyageFlight
        this.form.customerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.customerId, 'chineseName')
      }
    },
    // 加入货物
    addDetailHandler() {
      const detail = new WarehouseInDetail().fillDefaultValue().getData()
      detail.warehouseInUuid = this.form.uuid
      detail.dimension = '0*0*0*1'
      detail.sizeLength = 0
      detail.sizeWidth = 0
      detail.sizeHeight = 0
      detail.sizeQuantity = 1
      detail.quantity = 1
      detail.weight = 0.00
      detail.cubage = 0.000
      detail.singleWeight = 0.00
      detail.dimensionImperial = '0*0*0*1'
      detail.weightImperial = 0.00
      detail.cubAgeImperial = 0.000
      this.form.warehouseInDetailList.push(detail)
      this.calcSum()
    },
    // 删除货物
    delDetailHandler() {
      if (this.detailListSelectedRow) {
        const index = this.detailList.goodGridOptions.selectedRowIndex
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 删除文件
    delPhotoHandler() {
      if (this.photoListSelectedRow) {
        const index = this.photoList.gridOptions.selectedRowIndex
        if (index > -1) {
          this.form.businessDocumentVOList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 计算
    calcSum() {
      let quantitySum = 0
      let weightSum = 0
      let cubageSum = 0
      let weightSumImperial = 0
      let cubAgeSumImperial = 0
      for (const detail of this.form.warehouseInDetailList) {
        quantitySum += detail.quantity
        weightSum += Number(detail.weight)
        cubageSum += Number(detail.cubage)

        weightSumImperial += Number(detail.weightImperial)
        cubAgeSumImperial += Number(detail.cubAgeImperial)
      }
      this.form.quantitySum = quantitySum
      this.form.weightSum = weightSum
      this.form.cubageSum = cubageSum
      this.form.weightSumImperial = weightSumImperial
      this.form.cubAgeSumImperial = cubAgeSumImperial
    },
    // 重量改变
    async weightChange(params, imperial) {
      if (imperial) {
        params.data.weight = await JobUtils.calculateWeight(params.data.weightImperial)
      } else {
        params.data.weightImperial = await JobUtils.calculateWeight(params.data.weight, true)
      }
      if (params.data.quantity) {
        params.data.singleWeight = NumberUtils.ToFixed2(params.data.weight / params.data.quantity, 2)
        params.data.singleWeightImperial = await JobUtils.calculateWeight(params.data.singleWeight, true)
      }
      this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 体积改变
    async cubageChange(params, imperial) {
      if (imperial) {
        params.data.cubage = await JobUtils.calculateCubAge(params.data.cubAgeImperial)
      } else {
        params.data.cubAgeImperial = await JobUtils.calculateCubAge(params.data.cubage, true)
      }
      this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 单件重量改变
    async singleWeightChange(params, imperial) {
      if (imperial) {
        params.data.singleWeight = await JobUtils.calculateWeight(params.data.singleWeightImperial)
      } else {
        params.data.singleWeightImperial = await JobUtils.calculateWeight(params.data.singleWeight, true)
      }
      if (params.data.quantity) {
        params.data.weight = NumberUtils.ToFixed2(params.data.singleWeight * params.data.quantity, 2)
        params.data.weightImperial = await JobUtils.calculateWeight(params.data.weight, true)
      }
      this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    async calculationDimension(params) {
      const data = params.data
      // 取整数
      data.sizeLength = NumberUtils.ToFixed2(data.sizeLength, 1)
      data.sizeWidth = NumberUtils.ToFixed2(data.sizeWidth, 1)
      data.sizeHeight = NumberUtils.ToFixed2(data.sizeHeight, 1)
      data.sizeQuantity = Math.round(data.sizeQuantity)
      data.dimension = (data.sizeLength || 0) + '*' + (data.sizeWidth || 0) + '*' + (data.sizeHeight || 0) + '*' + (data.sizeQuantity || 0)
      // 计算英制
      data.dimensionImperial = await JobUtils.calculateDimension(data.sizeLength, data.sizeWidth, data.sizeHeight, data.sizeQuantity, true)
      await this.doCalculationDimension(params, data)
    },
    async calculationDimensionImperial(params) {
      const data = params.data
      // 取整数
      data.sizeLength = NumberUtils.ToFixed2(data.sizeLength, 1)
      data.sizeWidth = NumberUtils.ToFixed2(data.sizeWidth, 1)
      data.sizeHeight = NumberUtils.ToFixed2(data.sizeHeight, 1)
      data.sizeQuantity = Math.round(data.sizeQuantity)
      data.dimensionImperial = (data.sizeLength || 0) + '*' + (data.sizeWidth || 0) + '*' + (data.sizeHeight || 0) + '*' + (data.sizeQuantity || 0)
      // 计算公制
      data.dimension = await JobUtils.calculateDimension(data.sizeLength, data.sizeWidth, data.sizeHeight, data.sizeQuantity)
      await this.doCalculationDimension(params, data)
    },
    async doCalculationDimension(params, data) {
      data.quantity = data.sizeQuantity || 0
      const value = JobUtils.calcCubageQuantity(data.dimension)
      if (value) {
        data.cubage = NumberUtils.roundHalfUp(value[0], 3)
        data.cubAgeImperial = await JobUtils.calculateCubAge(data.cubage, true)
      }
      if (params.data.singleWeight) {
        params.data.weight = NumberUtils.ToFixed2(params.data.singleWeight * params.data.quantity, 2)
        params.data.weightImperial = await JobUtils.calculateWeight(params.data.weight, true)
      }
      this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 文件类型 编辑保存
    itemEditEndHandler(data) {
      if (data) {
        const list = []
        for (const p of this.form.businessDocumentVOList) {
          if (p.documentId === data.fileId) {
            p.fileCategory = data.fileCategory
          }
          list.push(p)
        }
        this.form.businessDocumentVOList = list
      }
    },
    selectJobNoHandler(data) {
      if (!data) {
        return
      }
      this.loading = getLoading()
      this.form.flightAndTime = ''
      getJobDetailFunc({ key: data }).then(res => {
        if (res.data) {
          this.clearJobData()
          this.jobKeyOld = this.form.jobKey
          Object.keys(this.form).forEach((key) => {
            if (res.data[key]) {
              this.form[key] = res.data[key]
            }
          })
          this.form.flightAndTime = this.voyageFlightStr()
          // 将入库状态更新为部分入库
          if (this.form.warehouseStatus !== WarehouseInState.FULLY_STORED.code) {
            this.form.warehouseStatus = WarehouseInState.PARTIAL_WAREHOUSING.code
          }
        } else {
          this.$message.warning(this.$t('Message.FailedPleaseRefreshAndAgain'))
        }
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 根据进仓编号获取业务
    warehouseNoChargeHandler(data) {
      setTimeout(() => {
        if (data === '') {
          return
        }
        this.loading = getLoading()
        this.filter.branchId = this.$store.getters.currentOfficeId
        this.filter.warehouseNo = this.form.warehouseNo
        this.filter.lob = this.lob
        queryJobByWarehouseNoFunc(this.filter).then(res => {
          this.loading.close()
          const j = res.data
          if (j === null || j.length === 0) {
            return
          }
          // 一个就直接用
          if (j.length === 1) {
            this.clearJobData()
            this.jobKeyOld = this.form.jobKey
            Object.keys(this.form).forEach((key) => {
              if (j[0][key]) {
                this.form[key] = j[0][key]
              }
            })
            this.form.flightAndTime = this.voyageFlightStr()
            // 将入库状态更新为部分入库
            if (this.form.warehouseStatus !== WarehouseInState.FULLY_STORED.code) {
              this.form.warehouseStatus = WarehouseInState.PARTIAL_WAREHOUSING.code
            }
          } else {
            // 多个选一下
            this.jobNosWindow.visible = true
            this.jobNosWindow.jobs = res.data
          }
        }).catch((err) => {
          this.$message.error(err)
        }).finally(() => {
          this.loading.close()
        })
      }, 100)
    },
    getLob() {
      const lob = this.form.lob ? this.form.lob : this.lob
      return lob === 'RE' || lob === 'RI'
    },
    // 船公司
    getCarrierName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = this.$t('SeaExport.AirlineCompany')
          break
        case 'SE':
        case 'SI':
          label = this.$t('SeaExport.ShippingCompany')
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.vessel')
          break
      }
      return label
    },
    // 船公司
    getFlightAndTime() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = this.$t('SeaExport.FlightAndTime')
          break
        case 'SE':
        case 'SI':
          label = this.$t('SeaExport.Vessel') + '/' + this.$t('SeaExport.Voyage')
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.voyageFlight')
          break
      }
      return label
    },
    getHblName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = 'HAWB No.'
          break
        case 'SE':
        case 'SI':
          label = 'HB/L'
          break
        case 'RE':
        case 'RI':
          label = this.$t('SeaExport.MblNo3')
          break
      }
      return label
    },
    voyageFlightStr() {
      let value = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
        case 'RE':
        case 'RI':
          value = this.form.voyageFlight
          break
        case 'SE':
        case 'SI':
          value = this.form.vessel
          if (value.length > 0 && this.form.voyageFlight) {
            value += '/'
          }
          value += this.form.voyageFlight
          break
      }
      return value
    },
    getMAWBName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = 'MAWB No.'
          break
        case 'SE':
        case 'SI':
          label = 'MB/L'
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.mbl')
          break
      }
      return label
    },
    // 清理job相关数据
    clearJobData() {
      this.form.jobNo = ''
      this.form.etdString = ''
      this.form.loadingPortEnglish = ''
      this.form.mbl = ''
      this.form.carrierName = ''
      this.form.destinationPortEnglish = ''
      this.form.hbl = ''
      this.form.voyageFlight = ''
      this.form.customerName = ''
      this.form.quantityContract = 0
      this.form.weightContract = 0.00
      this.form.cubageContract = 0.000
    },
    onFileTypeCellFocused(event) {
      this.photoList.gridOptions.selectedRowIndex = event.rowIndex
      if (event.column && event.column && event.column.colId === 'fileCategory') {
        this.fileTypeEdit(this.form.businessDocumentVOList[event.rowIndex])
      }
    },
    fileTypeEdit(data) {
      if (data !== null && this.isEditing) {
        this.fileTypeEditor.fileId = data.documentId
        this.fileTypeEditor.fileCategory = data.fileCategory
        this.fileTypeEditor.visible = true
      }
    },
    suppressKeyboardEvent(param) {
      const currInput = param.event.target.attributes['data-index']
      if (currInput) {
        if (param.event.keyCode === 9 && currInput.value === 'sizeQuantity') {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.warehousing-detail {
  .custom-textarea{
    textarea{
      height: 64px;
    }
  }
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .grid-list {
    flex-direction:row;
    width: 80%;
    max-width: 950px;
    min-width: 950px;
  }

  .required .el-form-item__label {
    color: #1F75D5!important
  }
}
</style>
